import axios from "axios";

const SCORING_SCHEMES_URL =
  "https://secureadmin.lkwb.com.np/api/scoring-schemes";

const authHeaders = (token) => ({
  headers: { authorization: `Bearer ${token}` },
});

// The API returns HTTP 200 with { success: false, message } on errors such as
// a missing login, so turn that into a rejected promise.
const unwrap = (res) => {
  if (res.data?.success === false) {
    const err = new Error(res.data.message || "Request failed");
    err.apiMessage = res.data.message;
    throw err;
  }
  return res.data?.data;
};

// GET /scoring-schemes -> [{ id, title, exam_type_label, mode_label, total_questions, total_marks, published_sets_count, ... }]
export const getScoringSchemes = (token) =>
  axios.get(SCORING_SCHEMES_URL, authHeaders(token)).then(unwrap);

// GET /scoring-schemes/:id -> { ...scheme, objective_marks, writing_marks, rules: [], entities: [] }
export const getScoringScheme = (id, token) =>
  axios.get(`${SCORING_SCHEMES_URL}/${id}`, authHeaders(token)).then(unwrap);

// GET /scoring-schemes/:id/sets -> { scheme, sets: [], pagination }
export const getSchemeSets = (schemeId, token) =>
  axios
    .get(`${SCORING_SCHEMES_URL}/${schemeId}/sets`, authHeaders(token))
    .then(unwrap);

// GET /scoring-schemes/:id/sets/:setId/questions -> { scheme, set, questions: [] }
export const getSetQuestions = (schemeId, setId, token) =>
  axios
    .get(
      `${SCORING_SCHEMES_URL}/${schemeId}/sets/${setId}/questions`,
      authHeaders(token)
    )
    .then(unwrap);

export const errorMessage = (err, fallback) =>
  err?.apiMessage || err?.response?.data?.message || fallback;

// POST /scoring-schemes/:id/sets/:setId/submit -> graded result
// { total_obtained_marks, total_marks, correct_answers, exam_id, scoring: { objective_marks, writing_marks, passed, breakdown: [], writing: [] } }
export const submitSetResult = (schemeId, setId, payload, token) =>
  axios
    .post(
      `${SCORING_SCHEMES_URL}/${schemeId}/sets/${setId}/submit`,
      payload,
      authHeaders(token)
    )
    .then(unwrap);

// POST /sets/:setId/buy/free -> claims a free set so its questions can be taken
export const claimFreeSet = (setId, token) =>
  axios
    .post(
      `https://secureadmin.lkwb.com.np/api/sets/${setId}/buy/free`,
      {},
      authHeaders(token)
    )
    .then(unwrap);

// GET /scoring-results?set_id= -> [{ result_id, exam_id, set_id, set, score, total_obtained_marks, total_marks, writing_status: { graded: 2 }, submitted_at }]
export const getSetResults = (setId, token) =>
  axios
    .get("https://secureadmin.lkwb.com.np/api/scoring-results", {
      ...authHeaders(token),
      params: { set_id: setId },
    })
    .then(unwrap);
